<template>  
   
        <v-card>
            <v-card-title>
                <h4 class="headline ma-0 grey--text text--darken-2">Firmenübersicht</h4>
            </v-card-title>
            <v-list>                      
                <v-list-tile 
                    v-on:click="preFilterFirmen(fa.total)"
                >
                    <v-list-tile-content>
                        <v-badge>
                            <span slot="badge">{{ fa.total.length }}</span>
                            <span >Firmen in der WWE MarkenDB</span>
                        </v-badge>
                    </v-list-tile-content>
                </v-list-tile>
                <v-divider class="my-2"></v-divider>
                <v-list-tile 
                    v-on:click="preFilterFirmen(fa.created)"
                >
                    <v-list-tile-content>
                        <v-badge>
                            <span slot="badge">{{ fa.created.length }}</span>
                            <span >Neue Firmen seit dem letzten Login</span>
                        </v-badge>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile 
                    v-on:click="preFilterFirmen(fa.updated)"
                >
                    <v-list-tile-content>
                        <v-badge>
                            <span slot="badge">{{ fa.updated.length }}</span>
                            <span >Bearbeitete Firmen seit dem letzten Login</span>
                        </v-badge>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-card>                
    
</template>

<script>



export default {
    
    props: [
        'fa'
    ],
    methods: {
        preFilterFirmen: function(arr) {
            this.$emit("preFilterFirmen", arr);
        }
    }
    

    
}
</script>

<style>
    
    
</style>




// WEBPACK FOOTER //
// firmenCard.vue?0bde600f